define.alias("shared/components/shared/social/twitter-deprecation/modal", "calendar/components/shared/social/twitter-deprecation/modal");